/**
 * SidebarSettingsPopover
 * Settings/filter popover for the task sidebar.
 * Contains toggle switches for sidebar display preferences.
 */

import { SlidersHorizontal } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';

interface SidebarSettingsPopoverProps {
  showDelegated: boolean;
  onShowDelegatedChange: (value: boolean) => void;
  showAllTasks: boolean;
  onShowAllTasksChange: (value: boolean) => void;
}

export function SidebarSettingsPopover({
  showDelegated,
  onShowDelegatedChange,
  showAllTasks,
  onShowAllTasksChange,
}: SidebarSettingsPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          title="Sidebar settings"
        >
          <SlidersHorizontal className="h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent side="right" align="start" sideOffset={6} className="w-56 p-0">
        <div className="p-3 space-y-3">
          <label className="flex items-center justify-between gap-3 cursor-pointer">
            <span className="text-sm">Show all tasks</span>
            <Switch
              checked={showAllTasks}
              onCheckedChange={onShowAllTasksChange}
            />
          </label>
          <label className="flex items-center justify-between gap-3 cursor-pointer">
            <span className="text-sm">Show delegated</span>
            <Switch
              checked={showDelegated}
              onCheckedChange={onShowDelegatedChange}
            />
          </label>
        </div>
      </PopoverContent>
    </Popover>
  );
}
